import { fmtPLPhone } from './fmtPLPhone.js';

export const PLPhoneFormatter = (selector, options = {}) => {
    const {
        event = 'input',
        root = document,
    } = options;

    const handler = (e) => {
        const el = e.target;

        if (!el.matches(selector)) return;

        const cursorPos = el.selectionStart;
        const before = el.value.length;

        el.value = fmtPLPhone(el.value);

        const after = el.value.length;
        const diff = after - before;

        el.setSelectionRange(cursorPos + diff, cursorPos + diff);
    };

    root.addEventListener(event, handler);
};
